import { BrandMark, type BrandMarkSize } from "@bw/shared/components";

/** Decorative full-detail brand mark for player-facing logo-scale contexts. */
export function Crest({ size = 52 }: { size?: BrandMarkSize | number }) {
  return (
    <BrandMark aria-hidden="true" size={size} />
  );
}
